module.exports = __webpack_public_path__ + "img/speed_green.f6beb72b.png";